import { render, staticRenderFns } from "./ClaimTplInside.vue?vue&type=template&id=acce16c4&"
import script from "./ClaimTplInside.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClaimTplInside.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ClaimTplInside.vue?vue&type=style&index=0&id=acce16c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports